"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mutuallyExclusiveUniqueClear = mutuallyExclusiveUniqueClear;
exports.requireNeutralIfDefaultSelectionIsNeutral = requireNeutralIfDefaultSelectionIsNeutral;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function mutuallyExclusiveUniqueClear(props, propName, componentName) {
  if (props['onClear'] && props['neutralOption']) {
    return new Error("".concat(componentName, " cannot have more than one of these props: `onClear`, or `neutralOption`"));
  }

  if (props['onClear'] && typeof props['onClear'] !== 'function') {
    return new Error("Invalid prop `onClear` of type `".concat(_typeof(props['onClear']), "` supplied to ").concat(componentName, ", expected `function`"));
  }

  if (props['neutralOption'] && typeof props['neutralOption'] !== 'boolean') {
    return new Error("Invalid prop `neutralOption` of type `".concat(_typeof(props['neutralOption']), "` supplied to ").concat(componentName, ", expected `boolean`"));
  }

  return null;
}

function requireNeutralIfDefaultSelectionIsNeutral(props, propName, componentName) {
  if (props['defaultSelected'] && typeof props['defaultSelected'] !== 'string') {
    return new Error("Invalid prop `defaultSelected` of type `".concat(_typeof(props['defaultSelected']), "` supplied to ").concat(componentName, ", expected `string`"));
  }

  if (props['defaultSelected'] === 'neutral' && !props['neutralOption']) {
    return new Error("".concat(componentName, " cannot have `defaultSelection` defined to `neutral` without having `neutralOption` truthy"));
  }

  return null;
}